// extracted by mini-css-extract-plugin
module.exports = {"headerList":"Header_headerList__1GWE6","headerLink":"Header_headerLink__3jb9C","headerItem":"Header_headerItem__1akbo"};